import { updateInterfaceState } from "./utils";
const sidebar_status = {
  visible: {
    sidebar_hidden: false,
  },
  hidden: {
    sidebar_hidden: true,
  },
};

const toggle_btn = document.querySelector(".toggle-sidebar");
const sidebar = document.querySelector("#sidebar");
const hamburger_btn = document.querySelector(".hamburger");
const bodyEl = document.body;

if (toggle_btn)
  toggle_btn.addEventListener("click", function (e) {
    e.preventDefault();
    sidebar.classList.toggle("hidden");
    sidebar.classList.contains("hidden")
      ? updateInterfaceState(sidebar_status.hidden)
      : updateInterfaceState(sidebar_status.visible);
    sidebar.dispatchEvent(
      new CustomEvent("toggled", {
        detail: !sidebar.classList.contains("hidden"),
      }),
    );
  });

if (hamburger_btn)
  hamburger_btn.addEventListener("click", function (e) {
    e.preventDefault();
    if (window.innerWidth < 769 || window.innerHeight < 351) {
      const nav = document.querySelector("#sidebar nav");
      nav.classList.toggle("open");
      hamburger_btn.querySelector("i").classList.toggle("fa-close");
      bodyEl.classList.toggle("no-scroll"); // Prevent scrolling when sidebar is open
      if (nav.classList.contains("open")) {
        updateInterfaceState(sidebar_status.visible);
      } else {
        updateInterfaceState(sidebar_status.hidden);
      }
    } else {
      sidebar.classList.remove("hidden");
      updateInterfaceState(sidebar_status.visible);
    }
  });

// if the user opens the mobile menu and enlarges the screen, the mobile menu must be closed to reset the scroll lock on the body
const mobileMenuMediaQueryWidth = window.matchMedia("(min-width: 768px)");
const mobileMenuMediaQueryHeight = window.matchMedia("(min-height: 350px)");

const checkIfCloseMobileMenu = (matches) => {
  if (matches) {
    const nav = document.querySelector("#sidebar nav");

    if (nav.classList.contains("open")) {
      nav.classList.remove("open");
      hamburger_btn.querySelector("i").classList.remove("fa-close");
      bodyEl.classList.remove("no-scroll");
      updateInterfaceState(sidebar_status.hidden);
    }
  }
};

mobileMenuMediaQueryWidth.addEventListener("change", (e) =>
  checkIfCloseMobileMenu(e),
);
mobileMenuMediaQueryHeight.addEventListener("change", (e) =>
  checkIfCloseMobileMenu(e),
);

const ACTIONS = ["INC", "DEC"];

function operateOnInput(target, action) {
  const input_id = target
    .closest(".spinner-container")
    .getAttribute("data-input");
  const input = document.getElementById(input_id);
  const minAttr = input.getAttribute("min");
  const maxAttr = input.getAttribute("max");
  const min = minAttr !== null ? parseFloat(minAttr) : null;
  const max = maxAttr !== null ? parseFloat(maxAttr) : null;
  const stepAttr = input.getAttribute("step");
  const step = !stepAttr || stepAttr === "any" ? 1 : parseFloat(stepAttr);
  const decimals =
    !stepAttr || stepAttr === "any"
      ? 2
      : stepAttr.includes(".")
        ? stepAttr.split(".")[1].length
        : 0;
  const current = parseFloat(input.value) || 0;
  if (action == ACTIONS[0]) {
    if (max === null || current < max)
      input.value = (current + step).toFixed(decimals);
  } else {
    if (min === null || current > min)
      input.value = (current - step).toFixed(decimals);
  }
  input.dispatchEvent(new Event("change"));
  const form = input.closest("form");
  if (form) form.dispatchEvent(new Event("change"));
}

export function initializeNumberSpinner() {
  /* CUSTOM SPINERS FOR INPUT TYPE NUMBER */
  const spinner_template = `
    <div class="spinner-container">
        <span class="up"><i class="fa-solid fa-caret-up"></i></span>
        <span class="down"><i class="fa-solid fa-caret-down"></i></span>
    </div>
    `;
  const number_inputs = document.querySelectorAll(".numberinput");
  number_inputs.forEach((el) => {
    const parent = el.closest("div");
    if (
      !parent.querySelector("input").disabled &&
      !parent.querySelector(".spinner-container")
    ) {
      el.insertAdjacentHTML("afterend", spinner_template);
      parent
        .querySelector(".spinner-container")
        .setAttribute("data-input", el.id);
    }
  });

  document.querySelectorAll(".spinner-container .up").forEach((el) => {
    el.addEventListener("click", function (e) {
      operateOnInput(e.target, ACTIONS[0]);
    });
  });

  document.querySelectorAll(".spinner-container .down").forEach((el) => {
    el.addEventListener("click", function (e) {
      operateOnInput(e.target, ACTIONS[1]);
    });
  });
}

initializeNumberSpinner();
